import { basic, act } from 'api';
import {
  UI_SET_LOADER,
  UI_SET_LOADER_TEXT,
  SET_UI_PROPERTY,
  GET_MARKDOWN_FILE,
  UI_GET_MASTER_DATA,
  UI_UPDATE_MASTER_DATA,
  GET_PARTNER_DATA,
  SET_PARTNER_DATA,
  GET_PARTNER_DATA_BY_TRANSACTION_ID
} from 'store/actions/ui';

export default {
  [UI_GET_MASTER_DATA]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasMasterData) {
        act.getMasterData().then(
          resp => {
            commit(UI_UPDATE_MASTER_DATA, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),

  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [UI_SET_LOADER_TEXT]: ({ commit }, text) => {
    commit(UI_SET_LOADER_TEXT, text);
  },

  [GET_MARKDOWN_FILE]: ({ commit, getters }, { url, field }) =>
    new Promise((resolve, reject) => {
      if (!getters.data(field)) {
        basic.getMarkdownFile(url).then(
          resp => {
            const data = resp.data;
            commit(SET_UI_PROPERTY, {
              field,
              value: data
            });
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),
  [GET_PARTNER_DATA]: ({ commit }, { id }) =>
    new Promise((resolve, reject) => {
      act
        .getPartnerData(id)
        .then(resp => {
          commit(SET_PARTNER_DATA, resp.data);
          resolve(resp.data);
        })
        .catch(err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        });
    }),

  [GET_PARTNER_DATA_BY_TRANSACTION_ID]: ({ commit }, { transactionId }) =>
    new Promise((resolve, reject) => {
      act
        .getPartnerDataByTransactionId(transactionId)
        .then(resp => {
          commit(SET_PARTNER_DATA, resp.data);
          resolve(resp.data);
        })
        .catch(err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        });
    })
};
